import React from "react";

function Warehouse({ fill, ...restProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill={fill ?? ""}
      viewBox="0 0 24 24"
      {...restProps}
    >
      <path
        d="M11.536 2.559c-.313.045-.527.1-.876.229-.271.099-5.873 2.902-6.44 3.222-.589.331-1.059.743-1.378 1.207-.191.277-.439.82-.525 1.149-.145.551-.162 1.348-.148 6.754.013 4.639.021 5.202.079 5.391a1.83 1.83 0 0 0 1.261 1.234c.261.072.587.075 8.511.075 7.868 0 8.251-.003 8.48-.073.609-.186 1.026-.59 1.234-1.197.086-.25.086-.256.098-5.43.013-5.367-.005-6.207-.145-6.74a4.794 4.794 0 0 0-.526-1.159c-.323-.468-.791-.879-1.381-1.211-.557-.314-6.167-3.122-6.44-3.223-.57-.213-1.277-.302-1.804-.228m1.093 1.743c.388.13 6.171 3.029 6.58 3.298.493.325.82.816.91 1.369.062.386.056 11.08-.007 11.143-.035.035-.348.048-1.158.048h-1.111l-.013-4.73c-.012-4.22-.021-4.753-.078-4.941a1.864 1.864 0 0 0-1.259-1.242c-.211-.061-.627-.067-4.493-.067-3.866 0-4.282.006-4.493.067a1.864 1.864 0 0 0-1.259 1.242c-.057.188-.066.721-.078 4.941l-.013 4.73H5.046c-.81 0-1.123-.013-1.158-.048-.063-.063-.069-10.757-.007-11.143.09-.553.417-1.044.91-1.369.399-.263 6.183-3.164 6.573-3.297.412-.14.849-.141 1.265-.001m3.483 6.586c.037.037.048 1.126.048 4.66v4.612H7.84v-4.612c0-3.534.011-4.623.048-4.66.07-.07 8.154-.07 8.224 0m-6.298 2.309a.865.865 0 0 0-.521.391.82.82 0 0 0 .298 1.121l.189.111h4.44l.189-.111a.82.82 0 0 0 0-1.418l-.189-.111-2.14-.007c-1.177-.003-2.197.007-2.266.024m0 4a.865.865 0 0 0-.521.391.82.82 0 0 0 .298 1.121l.189.111h4.44l.189-.111a.82.82 0 0 0 0-1.418l-.189-.111-2.14-.007c-1.177-.003-2.197.007-2.266.024"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
}

export default Warehouse;
